class PLPScrollTop {
  constructor() {
    this.button = document.getElementById("scroll-up");
    this.scrollVal = 300;
    this._init();
  }

  _init() {
    if (this.button) {
      window.onscroll = () => this._checkScroll();
      this._scrollUp();
    }
  }

  _checkScroll() {
    this.button.style.display =
      document.body.scrollTop > this.scrollVal ||
      document.documentElement.scrollTop > this.scrollVal
        ? "block"
        : "none";
  }

  _scrollUp() {
    this.button.addEventListener("click", () => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    });
  }
}

class AdventCalHandler {
  constructor() {
    this.daySpan = document.getElementById("advent-day");
  }

  dayStatus() {
    // Promo start date
    const startDay = new Date("Dec 9 2024");
    const today = new Date();

    // Calculate the difference in days
    const millisecondsInDay = 1000 * 60 * 60 * 24;
    const dateDifferenceInMilliseconds = today - startDay;
    const dateDifferenceInDays = Math.floor(
      dateDifferenceInMilliseconds / millisecondsInDay
    );

    const dayStatusOptions = [
      "first",
      "second",
      "third",
      "fourth",
      "fifth",
      "sixth",
      "seventh",
      "eighth",
      "ninth",
      "tenth",
      "eleventh",
      "twelfth",
    ];

    return dayStatusOptions[dateDifferenceInDays] || "___";
  }

  changeDayText() {
    if (this.daySpan) {
      this.daySpan.textContent = this.dayStatus();
    }
  }
}

class AdventCalTileHandler extends AdventCalHandler {
  constructor(item) {
    super();
    this.element = this._getElements(item);
    this._init();
  }

  _init() {
    const { now, start, end, item } = this.element;

    if (start <= now && end >= now) {
      this._changeContent();
    }
  }

  _getElements(element) {
    return {
      item: element,
      itemId: element.getAttribute("data-loop-id"),
      now: new Date(),
      start: new Date(element.getAttribute("data-promo-start")),
      end: new Date(element.getAttribute("data-promo-end")),
      coverImage: element.querySelector(".cover_image"),
      promoImage: element.querySelector(".promo_image"),
    };
  }

  _changeContent() {
    this.element.promoImage.classList.toggle("not-visible");
    this.element.coverImage.classList.toggle("not-visible");
  }
}

function initAdventCal() {
  const adventCal = document.querySelector(
    ".shopify-section--multi-column-advent"
  );

  if (adventCal) {
    const adventItems = [...adventCal.querySelectorAll(".multi-column__item")];
    const increment = 4;

    adventItems.forEach((item) => {
      new AdventCalTileHandler(item);
    });

    for (let i = 0; i < adventItems.length; i += increment) {
      // creates an array group
      const group = Array.from(adventItems).slice(i, i + increment);
      console.log(group);

      // checks if all elements are in the past
      const allPastDates = group.every((el) => {
        const end = new AdventCalTileHandler(el).element.end;
        const now = new AdventCalTileHandler(el).element.now;
        console.log(end < now);
        return end < now;
      });

      // if they are hide the group
      if (allPastDates) {
        group.forEach((el) => el.classList.add("hidden"));
      }
    }

    new AdventCalHandler().changeDayText();
  }
}

function visualNavSwiper() {
  const swiper = new Swiper(".swiper", {
    slidesPerView: 3,
    spaceBetween: 10,
    breakpoints: {
      750: {
        slidesPerView: 5,
      },
    },
  });
}

function initScripts() {
  new PLPScrollTop();
  visualNavSwiper();
  //   initAdventCal();
}

document.addEventListener("DOMContentLoaded", () => {
  initScripts();
});
